<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="leaving">
<h1>Leaving</h1>
<p style="text-indent:0em">When our turn came</p>
<p style="text-indent:0em">The light weight we made on the earth</p>
<p style="text-indent:0em">That should have made us suitable</p>
<p style="text-indent:0em">To be called to this travelling</p>
<p style="text-indent:0em">Made us apprehensive and unsure</p>
<p style="text-indent:0em">Even the gentle wind could knock us</p>
<p style="text-indent:0em">If we had new thoughts about this</p>
<p style="text-indent:0em">Or old thoughts as new thoughts</p>
<p style="text-indent:0em">We could always return</p>
<p style="text-indent:0em">Only a few days out of our lives</p>
<p style="text-indent:0em">It’s a free universe</p>
<p style="text-indent:0em">But those who did turn back found</p>
<p style="text-indent:0em">Years had passed in the world by then</p>
<p style="text-indent:0em">That night we disappeared off the face of the earth</p>
<p style="text-indent:0em">Even to ourselves</p>
<p style="text-indent:0em">We were riding in file on horses</p>
<p style="text-indent:0em">Around the side of the hill and lost to view</p>
<p style="text-indent:0em">Even to ourselves</p>
<p style="text-indent:0em">It’s not that the world ended as we crossed past the hill</p>
<p style="text-indent:0em">We didn’t pass a hill and pass out</p>
<p style="text-indent:0em">There were still housing estates and supermarkets</p>
<p style="text-indent:0em">And roads with cars</p>
<p style="text-indent:0em">We must have seemed an anomaly to those who saw us</p>
<p style="text-indent:0em">Though I am not convinced we could be seen</p>
<p style="text-indent:0em">Men astride or leading pack ponies</p>
<p style="text-indent:0em">Hats well down in light rain</p>
<p style="text-indent:0em">Heading into mountains</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?1c7de1f8